// Just a page that shows a message saying the booking request didn't work
// UPDATE: April 2026, sending an email if this happens so that we know when it's 
// happening. The code for that is in Book.js, before the line that navigates to this page

// MUI IMPORTS
import { Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

//THE ACTUAL PAGE
export const BookingError = () => {
  const navigate = useNavigate();

  return (
    <div className="page">
      <Typography variant="h4">
        "There was a problem sending your booking info. Please give us a call at
        519-596-2523, or email mail@landsendpark.com"
      </Typography>
      <Button variant="outlined" onClick={() => navigate("/")}>
        Back to home page
      </Button>
    </div>
  );
};
